import { render, staticRenderFns } from "./tabBookingMasterUICustomLayout.vue?vue&type=template&id=2878fefb&"
import script from "./tabBookingMasterUICustomLayout.vue?vue&type=script&lang=js&"
export * from "./tabBookingMasterUICustomLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2878fefb')) {
      api.createRecord('2878fefb', component.options)
    } else {
      api.reload('2878fefb', component.options)
    }
    module.hot.accept("./tabBookingMasterUICustomLayout.vue?vue&type=template&id=2878fefb&", function () {
      api.rerender('2878fefb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/tabBookingMasterUICustomLayout.vue"
export default component.exports